import {useEffect, createElement} from "react";

export const UseEffect = ({next, fn, deps}) => createElement(UseEffectComp, {fn, next, deps});

const UseEffectComp = ({fn, deps, next}) => {
    useEffect(fn, deps);
    return next?.() ?? null;
};
